import React from "react";
import { Successfully } from "../Common/CommonImages";
import { useNavigate } from "react-router-dom";
import { handleBackButton, handleBeforeUnload } from "../Common/EventHandlers";
import { Box, Typography, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const TestSubmitMessage = ({ company }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
    window.removeEventListener("popstate", handleBackButton);
    localStorage.clear();
    setTimeout(() => {
      navigate("/");
      window.location.reload();
    }, 1000);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bgcolor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          bgcolor: "#fff",
          borderRadius: "12px",
          maxWidth: "500px",
          width: { base: "90%", sm: "100%" },
          p: { base: 3, sm: 4 },
          position: "relative",
          textAlign: "center",
          boxShadow: 24,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#666",
          }}
          aria-label="close"
        >
          <Close />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={Successfully}
            alt="Success"
            style={{ width: "80px", height: "auto" }}
          />

          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#333",
              fontSize: { base: "20px", sm: "24px" },
              fontFamily: "'Roboto', sans-serif",
            }}
          >
            Test Submitted!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontSize: { base: "14px", sm: "16px" },
              lineHeight: 1.5,
              fontFamily: "'Roboto', sans-serif",
              mb: 1,
            }}
          >
            Your test is successfully submitted. Further details and procedures
            will be sent to you via email by <strong>{company}</strong>. Till
            then be prepared and all the best for future.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TestSubmitMessage;
